import React, { useEffect, useState } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { useLocation } from "wouter";
import { mdiAccountCircle } from "@mdi/js";

import authUtils from "../../script/utils/authUtils";
import { useInput } from "../hooks/useInput";

import { Box } from "../containers/Box";
import { Text } from "../components/Text";
import { Page } from "../containers/Page";
import { Line } from "../components/Line";
import { Title } from "../components/Title";
import { Banner } from "../containers/Banner";
import { Spacer } from "../components/Spacer";
import { Footer } from "../containers/Footer";
import { Button } from "../components/Button";
import { Content } from "../containers/Content";
import { PageBody } from "../containers/PageBody";
import { InputText } from "../components/InputText";
import { PageHeader } from "../containers/PageHeader";

const ErrorTextStyle = styled.p`
    margin-top: 2px;
    font-size: 11px;
    color: ${props => props.theme.redDark};
`;

const LinkStyle = styled.div`
    a {
        color: ${props => props.theme.white};
        text-decoration: none;
    }
    a:visited {
        color: ${props => props.theme.white};
        text-decoration: none;
    }
`;

export const Login = () => {

    const [, setLocation] = useLocation();

    const username = useInput("username", "");
    const password = useInput("password", "");
    const [error, setError] = useState(false);

    const imprintUrl = "https://www.prehcm-services.de/impressum";
    const privacyUrl = "https://www.prehcm-services.de/datenschutz";

    useEffect(() => {
        username.focus();
    }, []);

    const onKeyDown = ({ keyCode }) => {
        const enterKeyCode = 13;
        if (keyCode === enterKeyCode) {
            onLogin();
        }
    };

    const onLogin = async () => {
        const valid = await authUtils.login(username.value, password.value);
        if (valid === true) {
            setError(false);
            setLocation("/entries");
        } else {
            setError(true);
        }
    };

    return (
        <Page>
            <PageHeader basic />
            <PageBody>
                <Content>
                    <Banner />
                    <Box maxWidth="400px">
                        <Title size="small" svgIcon={mdiAccountCircle} value={intl.get("login.login")} />
                        <InputText {...username.bind}
                            maxLength="50"
                            title={intl.get("login.username")}
                            onKeyDown={event => onKeyDown(event)} />
                        <Spacer size="small" variant="horizontal" />
                        <InputText {...password.bind}
                            password
                            maxLength="50"
                            title={intl.get("login.password")}
                            onKeyDown={event => onKeyDown(event)} />
                        {error &&
                            <ErrorTextStyle>{intl.get("login.error.login")}</ErrorTextStyle>
                        }
                        <Spacer size="medium" variant="horizontal" />
                        <Line />
                        <Spacer size="medium" variant="horizontal" />
                        <Button
                            id="loginButton"
                            onClick={event => onLogin(event)}
                            value={intl.get("login.login")} />
                    </Box>
                    <Footer>
                        <LinkStyle>
                            <Text>
                                <a href={imprintUrl}>{intl.get("login.footer.imprint")} | </a>
                                <a href={privacyUrl}>{intl.get("login.footer.privacy")} </a>
                            </Text>
                        </LinkStyle>
                    </Footer>
                </Content>
            </PageBody>
        </Page>
    );
};